import { useAppSelector } from 'hooks/redux';
import { List } from 'immutable';
import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import type { taxLineItemsTypes } from 'app-components/flux/tax-line-items';
import { taxLineItemsSelectors } from 'app-components/flux/tax-line-items';

import { useMultiFields } from 'app-components/flux/categories/categoryFormHooks';
import useStyles from './styles';

type Props = {
  type: string;
};

const TaxLineItemBusiness = ({ type }: Props) => {
  const { classes } = useStyles();

  const { value, error, helperText, onValueChange } = useMultiFields('businessTaxInfo', type);
  const { taxForm, taxLineItem } = value;

  const taxLineItemsByTaxFormId = useAppSelector(taxLineItemsSelectors.getTaxLineItemsByTaxFormId);
  const taxLineItems: List<taxLineItemsTypes.TaxLineItem> = (taxForm && taxLineItemsByTaxFormId.get(taxForm)) || List();
  const taxDescription =
    (taxLineItems && taxLineItem && taxLineItems.find((item) => item.get('id') === taxLineItem)?.description) ||
    'Select a tax line to see a description';

  return (
    <>
      {taxForm ? (
        <TextField
          variant='filled'
          label='Tax line item'
          name='taxLineItem'
          value={value.taxLineItem || ''}
          className={classes.dropDown}
          select
          onChange={(e) => onValueChange(e.target)}
          id='tax-line-item-dropdown'
          error={(!value.taxLineItem || value.taxLineItem === '') && error}
          helperText={helperText}
          InputLabelProps={{
            classes: {
              root: classes.inputLabel,
            },
          }}
        >
          {taxLineItems &&
            taxLineItems.map((lineItem: taxLineItemsTypes.TaxLineItem) => (
              <MenuItem value={lineItem.id} key={lineItem.id}>
                <Tooltip title={lineItem.description} placement='right'>
                  <span>{lineItem.name}</span>
                </Tooltip>
              </MenuItem>
            ))}
        </TextField>
      ) : (
        <></>
      )}

      {taxForm && taxLineItem && (
        <Stack spacing={0.5}>
          <Typography variant='paragraphRegular'>Description</Typography>
          <Typography
            variant='bodyRegular'
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {taxDescription}
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default TaxLineItemBusiness;
